import React from 'react'
import { ViewReportList, balanceColumnDefinition } from 'pages/reports'
import {
  useGetBalanceReportQuery,
  useLazyGetBalanceReportQuery,
} from 'features'
import { ErrorBoundary, SchoolCycleSelect, SearchInput } from 'components'
import { LazyReportExport } from 'pages/reports/LazyReportExport'
import { apiSlice } from 'app/api/apiSlice'
import { useSelector } from 'react-redux'

export default function ViewBalanceByDNIReport() {
  const [search, setSearch] = React.useState('')

  const [customFilterParams, setCustomFilterParams] = React.useState({
    schoolcycle: `${new Date().getFullYear()}`,
  })
  function handleSchoolCycleChange(event) {
    setCustomFilterParams({
      ...customFilterParams,
      schoolcycle: event.target.value,
    })
  }

  let querySubscriptionArgs = useSelector(state => {
    let subscriptions = state.api.subscriptions
    let endpointName = "getBalanceReport"
    let activeSubscriptionUrl = Object.entries(subscriptions).reduce((acc, [key, value]) => {

      if (key.includes(endpointName) && Object.keys(value).length > 0) {
        acc = key
        return acc
      }
      return acc
    }, "")
    let lastQueryArguments = state.api.queries?.[activeSubscriptionUrl]?.originalArgs
    return lastQueryArguments
  })

  let reportHeader = [
    [
      'Reporte de Balance de ASL ciclo lectivo ' +
      customFilterParams.schoolcycle,
    ],
    [''],
  ]
  if (search) {
    reportHeader.push(['busqueda (dni/nombre): ' + search])
    reportHeader.push([''])
  }

  return (
    <div>
      <ErrorBoundary fallback={<div>Error</div>}>
        <div className="flex flex-row justify-end items-center mt-32 gap-4 ">
          <SearchInput
            onChange={(e) => setSearch(e.target.value)}
            value={search}
            placeholder="Buscador"
          />{' '}
          <SchoolCycleSelect
            value={customFilterParams.schoolcycle}
            onChange={handleSchoolCycleChange}
          />
          <LazyReportExport
            query={useLazyGetBalanceReportQuery}
            columns={balanceColumnDefinition}
            title={`Balance de ASL`}
            fileName={`Balance de ASL ${search ? ' - DNI: ' + search : customFilterParams.schoolcycle
              }`}
            reportHeader={reportHeader}
            queryParams={querySubscriptionArgs}
          >
            Exportar vista actual
          </LazyReportExport>
        </div>
        <ViewReportList
          query={useGetBalanceReportQuery}
          rowIdKey="studentid"
          columnDefinition={balanceColumnDefinition}
          filterCustomParams={customFilterParams}
          search={search}
        />
      </ErrorBoundary>
    </div>
  )
}
